import Stack from '@mui/material/Stack';

type StackRowProps = {
  children: React.ReactNode;
};

const StackRow: React.FC<StackRowProps> = (props) => {
  return (
    <Stack
      direction='row'
      spacing={'8px'}
      justifyContent={'flex-start'}
      alignItems={'center'}
      width={'100%'}
      my={'8px'}
    >
      {props.children}
    </Stack>
  );
};

export default StackRow;
